/** The launcher's speech bubble (24×24, filled): also School's header chat button, so both look the same. */
export const CHAT_GLYPH = 'M4 4h16a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1h-8.5L7 20.5V17H4a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1z';
